export const projectFonts = {
  primaryFont: "Lora-Regular",
  secondaryFont: "NotoSans-Bold"
}
